import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" REC ")
const _hoisted_2 = {
  key: 1,
  class: "qa-sc-recording"
}
const _hoisted_3 = { class: "flex row nowrap qa-sc-recording-buttons" }
const _hoisted_4 = { class: "qa-sc-recording-length" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_RecordButton = _resolveComponent("RecordButton")!
  const _component_AudioPlayer = _resolveComponent("AudioPlayer")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["qa-session-controls", {
      'qa-sc--quote-controls': _ctx.mode === 'quote',
      'qa-sc--review-controls': _ctx.mode === 'review',
    }])
  }, [
    (_ctx.mode === 'quote')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!(_ctx.coachMode && _ctx.displayText))
            ? (_openBlock(), _createBlock(_component_IconButton, {
                key: 0,
                icon: _ctx.shuffle ? 'shuffle_on' : 'shuffle',
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.shuffle = !_ctx.shuffle), ["prevent"])),
                title: `turn shuffle ${_ctx.shuffle ? 'off' : 'on'}`,
                disabled: _ctx.isRecording
              }, null, 8, ["icon", "title", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.coachMode)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 1,
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isRecording)
                    ? (_openBlock(), _createBlock(_component_RecordButton, {
                        key: 0,
                        icon: "fiber_manual_record",
                        class: "qa-sc-rec-button",
                        border: "",
                        onClick: _withModifiers(_ctx.record, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_RecordButton, {
                            icon: "close",
                            class: "qa-sc-recording-cancel",
                            onClick: _withModifiers(_ctx.stop, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Cancel'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_RecordButton, {
                            icon: "check",
                            class: "qa-sc-recording-next",
                            onClick: _withModifiers(_ctx.next, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Next'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.recordingLength), 1)
                      ]))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.displayText)
                  ? (_openBlock(), _createBlock(_component_RecordButton, {
                      key: 0,
                      icon: "close",
                      class: "qa-sc-incorrect",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.review(false)), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Incorrect'), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_RecordButton, {
                  icon: "refresh",
                  class: "qa-sc-flip",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.displayText = !_ctx.displayText), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Flip'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.displayText)
                  ? (_openBlock(), _createBlock(_component_RecordButton, {
                      key: 1,
                      icon: "check",
                      class: "qa-sc-correct",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.review(true)), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Correct'), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64)),
          (!(_ctx.coachMode && _ctx.displayText))
            ? (_openBlock(), _createBlock(_component_IconButton, {
                key: 3,
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.skip(_ctx.currentIndex)), ["prevent"])),
                icon: "skip_next",
                title: "skip current verse",
                disabled: _ctx.isRecording
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.mode === 'review')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_RecordButton, {
              icon: "close",
              class: "qa-sc-incorrect",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.review(false)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Incorrect'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_AudioPlayer, {
              src: _ctx.audioSrc,
              disabled: !_ctx.audioSrc,
              class: "qa-sc-player",
              autoPlay: _ctx.autoPlay,
              "onUpdate:autoPlay": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.autoPlay) = $event)),
              speed: _ctx.speed,
              "onUpdate:speed": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.speed) = $event)),
              state: _ctx.state
            }, null, 8, ["src", "disabled", "autoPlay", "speed", "state"]),
            _createVNode(_component_RecordButton, {
              icon: "check",
              class: "qa-sc-correct",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.review(true)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$mqs.xs ? '' : 'Correct'), 1)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}